module.exports = __webpack_public_path__ + "static/visionar_augmented_reality_app-developer-job_792-352-1-adbde5fc5567e8b1dcf7dccea431287f.jpg";